import { isEqual } from 'lodash';
import { distinctUntilChanged, map, tap } from 'rxjs';
import { dispatchAction } from '@ardoq/rxbeach';
import { GetAdditionalRoutineArgs } from '../../types';
import { treeScrollHeightChanged } from '../../actions';

export const getPublishScrollHeight = ({
  navigator$,
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  navigator$.pipe(
    map(({ rootLayoutBox: { scrollHeight } }) => scrollHeight),
    distinctUntilChanged((a, b) => isEqual(a, b)),
    tap(scrollHeight =>
      dispatchAction(
        treeScrollHeightChanged({ scrollHeight }),
        navigatorConfiguration.actionNamespace
      )
    )
  );
